{{#> elements/_dt }}
  {{!-- We don't show an * on the label, instead we want to show it on the individual fields. --}}
  {{> elements/_label required=false}}
{{/elements/_dt}}
<dd>
  <dl>
      <dt>
        {{> elements/_label id="address_street" label="Address"}}
      </dt>
      <dd>
        {{> elements/_input type="text" name="address][street" id="address_street" value=(lookup value 'street')}}
      </dd>
      <dt>
        {{> elements/_label id="address_second_line" label="Apartment, suite, building (optional)" required=false}}
      </dt>
      <dd>
        {{> elements/_input type="text" name="address][second_line" id="address_second_line" value=(lookup value 'second_line') required=false}}
      </dd>
      <dt>
        {{> elements/_label id="address_city" label="City"}}
      </dt>
      <dd>
        {{> elements/_input type="text" name="address][city" id="address_city" value=(lookup value 'city')}}
      </dd>
      <dd>
        <dl class="field-input-group">
          <dd class="field-input select field-input--size-medium">
            <dl>
              <dt>
                {{> elements/_label id="address_state" label="State"}}
              </dt>
              <dd>
                {{> elements/_select name="address][state" id="address_state" value=(lookup value 'state') options=state_options}}
              </dd>
            </dl>
          </dd>

          <dd class="field-input field-input--size-medium">
            <dl>
              <dt>
                {{> elements/_label id="address_zip_code" label="Zip code"}}
              </dt>
              <dd>
                {{> elements/_input type="text" name="address][zip_code" id="address_zip_code" value=(lookup value 'zip_code') attributes=(spread zip_code_attributes)}}
              </dd>
            </dl>
          </dd>
        </dl>
      </dd>
  </dl>
</dd>

